import {
  getWhiteLabelLogoUrl,
  isIpasoftWhiteLabel,
  usesJimssoftHero,
} from "../../config/white-label";

const publicBase = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

const exaccHeroLightUrl = `${publicBase}/image-light.png`;
const exaccHeroDarkUrl = `${publicBase}/image-dark.png`;
const jimssoftHeroDarkUrl = `${publicBase}/jims-kv1.jpg`;
const jimssoftHeroLightUrl = `${publicBase}/jims-kv1-light.jpg`;

function getJimssoftHeroUrl(isDarkMode) {
  return isDarkMode ? jimssoftHeroDarkUrl : jimssoftHeroLightUrl;
}

function getDefaultExaccHeroUrl(isDarkMode) {
  return isDarkMode ? exaccHeroDarkUrl : exaccHeroLightUrl;
}

/** Theme-aware PNG (default), Jim's KV (/public), or tenant logo (ipasoft). */
export function getLoginHeroUrl(isDarkMode = false) {
  if (usesJimssoftHero()) {
    return getJimssoftHeroUrl(isDarkMode);
  }
  if (isIpasoftWhiteLabel()) {
    return getWhiteLabelLogoUrl();
  }
  return getDefaultExaccHeroUrl(isDarkMode);
}

/** Fallback when hero image fails to load. */
export function getLoginHeroFallbackUrl(isDarkMode = false) {
  if (usesJimssoftHero()) {
    return getJimssoftHeroUrl(isDarkMode);
  }
  if (isIpasoftWhiteLabel()) {
    return getWhiteLabelLogoUrl();
  }
  return getDefaultExaccHeroUrl(isDarkMode);
}

export function getRegisterHeroUrl(isDarkMode = false) {
  if (usesJimssoftHero()) {
    return getJimssoftHeroUrl(isDarkMode);
  }
  if (isIpasoftWhiteLabel()) {
    return getWhiteLabelLogoUrl();
  }
  return getDefaultExaccHeroUrl(isDarkMode);
}
